import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';

import BreadCrumb from 'jbc-front/components/BreadCrumb';
import { CLIENT_SETTINGS, CLIENT_PAYROLL_RULES_GROUP_LIST } from 'src/constants/EndpointUrls';

import { PAYROLL_RULES_GROUP_FORM } from 'src/constants/FormNames';

import { getItem, getItemErrors, setItem, mergeItemFields } from 'src/reducers/common/itemReducer';
import { REDUCER_NAME, newPayrollRulesGroup } from 'src/reducers/clients/payrollRulesGroups';

import PayrollRulesGroupForm from './containers/PayrollRulesGroupForm';
import { calculateDateForForm } from './utils';

let NewPayrollRulesGroupForm = reduxForm({
  form: PAYROLL_RULES_GROUP_FORM
})(PayrollRulesGroupForm);

const mapStateToProps = (state, ownProps) => ({
  initialValues: {
    ...getItem(REDUCER_NAME, state),
    ...calculateDateForForm(getItem(REDUCER_NAME, state)),
    prescribedWorkingHoursPerDay: _.get(getItem(REDUCER_NAME, state), 'prescribedWorkingHoursPerDay') || '8:00',
    avgRegularWorkingDaysPerMonth: _.get(getItem(REDUCER_NAME, state), 'avgRegularWorkingDaysPerMonth') || '0.00',
    avgRegularWorkingHoursPerMonth: _.get(getItem(REDUCER_NAME, state), 'avgRegularWorkingHoursPerMonth') || '0:00',
    timingOfTaxDeduction: _.get(getItem(REDUCER_NAME, state), 'calcSscSeparately') || '0'
  },
  isNewForm: true,
  isCopyForm: ownProps.isCopyForm,
  errors: getItemErrors(REDUCER_NAME, state)
});
const mapDispatchToProps = dispatch => ({
  onSubmit: data => {
    dispatch(newPayrollRulesGroup(data));
  }
});

NewPayrollRulesGroupForm = connect(mapStateToProps, mapDispatchToProps)(NewPayrollRulesGroupForm);

const NewPayrollRulesGroup = ({ dispatch, clientPayrollRulesGroup, copyOrgId, match }) => {
  const { path } = match;
  const isCopyForm = path.match(/copy/);
  const { t } = useTranslation();

  dispatch(setItem(REDUCER_NAME, clientPayrollRulesGroup));
  dispatch(mergeItemFields(REDUCER_NAME, { copyOrgId }));

  return (
    <div>
      <div className="l-title-wrap">
        <h1 className="m-title-main">{t('features.PayrollRulesGroups.NewPayrollRulesGroup.Add_new_salary_rule')}</h1>
      </div>
      <div className="l-wrap-xs">
        <div className="u-mb20">
          <BreadCrumb>
            <BreadCrumb.Item label={t('components.SideMenu.SideMenu.setting')} path={CLIENT_SETTINGS} />
            <BreadCrumb.Item
              label={t('features.PayrollRulesGroups.PayrollRulesGroupsList.salary_rule_group_list')}
              path={CLIENT_PAYROLL_RULES_GROUP_LIST}
            />
            <BreadCrumb.Item label={t('features.PayrollRulesGroups.NewPayrollRulesGroup.Add_new_salary_rule')} />
          </BreadCrumb>
        </div>
        <NewPayrollRulesGroupForm isCopyForm={isCopyForm} />
      </div>
    </div>
  );
};

export default connect()(NewPayrollRulesGroup);
